import $http from './http'
import filter from '../utils/filter';

const application = {
  // 获取应用列表
  async getAppList (params) {
    return $http('/application', {
      method: 'GET',
      params: { ...filter(params) }
    });
  },
  // 创建应用
  async createApplication (params) {
    return $http('/create/application', {
      method: 'POST',
      data: { ...filter(params) }
    });
  },
  // 删除应用
  async delApplication (params) {
    return $http('/delete/application', {
      method: 'POST',
      data: { ...params }
    });
  },
  // 获取应用信息
  async getPlatform (params) {
    return $http('/application/platform', {
      method: 'GET',
      params: { ...params }
    })
  }
};

export default application;



// WEBPACK FOOTER //
// ./src/api/application.js